import { encode, decode } from 'js-base64';

export function ye(valor:string){
  return encode(valor);
}

export function xd(valor:string){
  return decode(valor);
}

export async function recover(key: string): Promise<string | null> {
  return null;
}

export async function timeOut(time: number): Promise<unknown> {
  const promise = new Promise((resolve, reject) =>
    setTimeout(() => resolve("promise 1 resolved"), time * 1000)
  );

  return promise;
}

// Convert file to base64 string
export async function fileToBase64(file: File): Promise<unknown> {
  const promise = new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function (event: any) {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });
  return promise;
}

export const maskCPF = [
  /[0-9]/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
];

export const maskData = [
  /[0-9]/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskDataSuspensao = [/[0-9]/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

export const maskCEP = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

export const maskTelefone = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskCelular = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const currencyConfigMoney = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

export function formatMoney(valor: number) {
  if (!valor){
    return
  }
  return valor
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}

export function moneyToNumber(valor: string){
  if (typeof valor == "number"){
    return valor
  }
  valor = valor.replace(/\./g, "")
  valor = valor.replace(",", ".")
  return parseFloat(valor)
}